import { MailCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";

import { api, formatApiError } from "@/lib/api";


export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setMessage("");
    setIsSubmitting(true);

    try {
      const response = await api.post("/auth/forgot-password", { email });
      setMessage(response.data.message);
    } catch (requestError) {
      setError(formatApiError(requestError));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="auth-page" data-testid="forgot-password-page">
      <section className="auth-panel" aria-labelledby="forgot-password-title">
        <p className="eyebrow">ANEKA / PASSWORD</p>
        <MailCheck aria-hidden="true" className="auth-icon" size={28} />
        <h1 id="forgot-password-title" data-testid="forgot-password-title">Reset password</h1>
        <p className="auth-copy">Kami mengirim tautan sekali pakai ke email akun Anda.</p>
        <form className="auth-form" data-testid="forgot-password-form" onSubmit={handleSubmit}>
          <label htmlFor="forgot-email">Email akun</label>
          <input
            autoComplete="email"
            data-testid="forgot-password-email-input"
            id="forgot-email"
            onChange={(event) => setEmail(event.target.value)}
            required
            type="email"
            value={email}
          />
          {message && <p className="form-success" data-testid="forgot-password-success">{message}</p>}
          {error && <p className="form-error" data-testid="forgot-password-error" role="alert">{error}</p>}
          <button data-testid="forgot-password-submit-button" disabled={isSubmitting} type="submit">
            {isSubmitting ? "Mengirim…" : "Kirim tautan reset"}
          </button>
        </form>
        <Link data-testid="back-to-login-link" to="/login">Kembali ke masuk</Link>
      </section>
    </main>
  );
}